import type { ApiResponse, LeaderboardCircuit } from '@kangaroo/shared';

import { api } from '../lib/api';

export async function fetchLeaderboard() {
  const response = await api.get<ApiResponse<LeaderboardCircuit[]>>('/sessions/leaderboard');
  return response.data.data;
}

export const leaderboardKey = ['leaderboard'] as const;
